export function GlassCard({ children, className = "", strong = false, ...rest }) {
  return (
    <div
      className={`${strong ? "glass-strong" : "glass"} p-6 ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
